/**
 * Nexus System-Settings Fixture.
 * Spec: lmm-wiki/wiki/orbit-specs/nexus-system-settings.md
 *
 * Allowlist im Backend: src/controllers/admin/settings.controller.js
 */

const DEFAULTS = [
  { key: 'CORS_ALLOWED_ORIGINS', type: 'csv', value: 'https://orbit.valitype.net,https://dash.valitype.com', group: 'API' },
  { key: 'BIMI_PUBLIC_BASE_URL', type: 'url', value: 'https://bimi.valitype.com', group: 'Mail' },
  { key: 'BIMI_S3_REGION', type: 'string', value: 'eu-central-1', group: 'Mail' },
  { key: 'BIMI_S3_BUCKET', type: 'string', value: 'valitype-bimi', group: 'Mail' },
  { key: 'CORE_BASE_URL', type: 'url', value: 'https://core.api.valitype.net', group: 'API' },
  { key: 'JWT_ISSUER', type: 'string', value: 'core.api.valitype.net', group: 'API' },
  { key: 'PLUGIN_LOAD_STRICT', type: 'boolean', value: false, group: 'Plugins' },
  { key: 'POSTMASTER_IMAP_HOST', type: 'string', value: 'imap.example.com', group: 'Postmaster' },
  { key: 'POSTMASTER_IMAP_PORT', type: 'integer', value: 993, group: 'Postmaster' },
  { key: 'POSTMASTER_IMAP_USER', type: 'string', value: 'postmaster@valitype.com', group: 'Postmaster' },
  { key: 'USAGE_POLL_CRON', type: 'string', value: '0 */4 * * *', group: 'Schedules' },
  { key: 'POSTMASTER_SCAN_CRON', type: 'string', value: '*/15 * * * *', group: 'Schedules' },
];

function persist() {
  if (typeof window === 'undefined') return null;
  if (!window.__ORBIT_NEXUS_SETTINGS__) {
    window.__ORBIT_NEXUS_SETTINGS__ = Object.fromEntries(DEFAULTS.map((s) => [s.key, s.value]));
  }
  return window.__ORBIT_NEXUS_SETTINGS__;
}

export function nexusSettingsFixture() {
  const db = persist() ?? {};
  return {
    settings: DEFAULTS.map((s) => ({
      ...s,
      value: db[s.key] ?? s.value,
      updated_at: new Date(Date.now() - 3600_000).toISOString(),
    })),
  };
}

export function applyNexusSettingPatch(key, value) {
  const db = persist();
  if (db) db[key] = value;
}
